export const shouldCheckTemporaryRegistration = businessScopeType => businessScopeType === 30;

export const resolveTemporaryRegistrationCheck = result => ({
  platformMatched: result?.platformState === true,
  notRegistered: result?.platformState === true && result?.driverState === false
});

export const shouldEnterTransportContractReview = (showReviewKeys, hasTransportContract, platformMatched) =>
  showReviewKeys && hasTransportContract && !platformMatched;
